import { useCallback, useEffect } from "react";
import { useLocation } from "react-router";
import queryString from "querystring";
import { useWizard } from "../../wizard/context";
import { IWizardConfig } from "../../wizard/types";

interface propTypes {
  getViewAcademicConfig?: (id: string) => IWizardConfig;
  getViewProgramConfig?: (id: string) => IWizardConfig;
  getViewCourseConfig?: (id: string) => IWizardConfig;
}

export const useCheckForViewModal = ({
  getViewAcademicConfig,
  getViewProgramConfig,
  getViewCourseConfig,
}: propTypes) => {
  const { openWizard } = useWizard();
  const location = useLocation();

  const queryParams = queryString.parse(
    location.search.split("?").join(""),
    " ",
  );

  const entityId =
    queryParams.viewAcademicId ||
    queryParams.viewProgramId ||
    queryParams.viewCourseId;

  const openModal = useCallback(() => {
    if (
      typeof queryParams.viewAcademicId === "string" &&
      getViewAcademicConfig
    ) {
      openWizard(getViewAcademicConfig(queryParams.viewAcademicId));
    } else if (
      typeof queryParams.viewProgramId === "string" &&
      getViewProgramConfig
    ) {
      openWizard(getViewProgramConfig(queryParams.viewProgramId));
    } else if (
      typeof queryParams.viewCourseId === "string" &&
      getViewCourseConfig
    ) {
      openWizard(getViewCourseConfig(queryParams.viewCourseId));
    }
  }, [
    getViewAcademicConfig,
    getViewProgramConfig,
    getViewCourseConfig,
    openWizard,
    queryParams.viewAcademicId,
    queryParams.viewProgramId,
    queryParams.viewCourseId,
  ]);

  useEffect(() => {
    if (entityId) {
      openModal();
    }
  }, [openModal]);
};
